import styled from 'styled-components'

export const RadioButtonErrorWrapperContainer = styled.div``

export const ErrorMessageWrapper = styled.div`
  margin-top: 3px;
  p {
    color: #ff4949;
  }
`
